// OA 后端基础地址：优先使用环境变量 VUE_APP_OA_URL，便于不同环境配置
export const OA_BASE_URL = process.env.VUE_APP_OA_URL || '';
export const OA_CLIENT_ID = process.env.VUE_APP_OA_CLIENT_ID || 'e5cd7e4891bf95d1d19206ce24a7b32e';
export const OA_TENANT_ID = process.env.VUE_APP_OA_TENANT_ID || '000000';
export const OA_GRANT_TYPE = process.env.VUE_APP_OA_GRANT_TYPE || 'password';

// 若依 OA 认证头构建（参考 im-uniapp/common/oa/ruoyiUtils.js 的 getRuoyiUserHeaders）
export function getOaHeaders() {
  // 基础头部，至少保证 JSON 请求正常
  const baseHeaders = {
    'Content-Type': 'application/json;charset=utf-8',
    clientid: OA_CLIENT_ID,
  };

  // 1. 读取本地存储中的用户信息和 token
  let ruoyiUserInfo = localStorage.getItem('ruoyi_user_info');
  const ruoyiToken = localStorage.getItem('Admin-Token');

  // 如果本地没有任何 ruoyi 信息，先返回基础头部，不再抛异常
  if (!ruoyiUserInfo && !ruoyiToken) {
    console.warn('web 提示：本地未发现 ruoyi OA 登录信息，将不携带用户认证头调用 OA 接口');
    return baseHeaders;
  }

  // 兼容两种存储方式：
  // - 直接存对象（某些场景 localStorage.setItem 会先 JSON.stringify）
  // - 已经是 JSON 字符串
  try {
    if (typeof ruoyiUserInfo === 'string') {
      ruoyiUserInfo = JSON.parse(ruoyiUserInfo);
    }
  } catch (e) {
    console.warn('web 解析 ruoyi_user_info 失败，将仅携带 token 头:', e);
  }

  console.log('web 获取到的若依用户信息:', ruoyiUserInfo);
  console.log('web 获取到的若依 Admin-Token:', ruoyiToken);

  const headers = { ...baseHeaders };

  // 尽可能附加 token 和用户信息，但不强制
  if (ruoyiToken) {
    headers['Authorization'] = 'Bearer ' + ruoyiToken;
  } else {
    console.warn('web 提示：未获取到 Admin-Token，将不携带 Authorization 头调用 OA 接口');
  }

  if (ruoyiUserInfo && ruoyiUserInfo.userId && ruoyiUserInfo.userName) {
    headers.userId = String(ruoyiUserInfo.userId);
    headers.userName = ruoyiUserInfo.userName;
  } else {
    console.warn('web 提示：ruoyi_user_info 不完整，将不携带 userId/userName 调用 OA 接口');
  }

  console.log('web 构建的 OA 请求头:', headers);
  return headers;
}
